import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import ScrollToTop from "react-scroll-to-top";

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import './styles.css'
import App from './routes/App'
import Preproduction from './routes/Preproduction'
import Production from './routes/Production'
import Postproduction from './routes/Postproduction'
import Footer from './components/footer';
import Header from './components/header';

import './i18n';

const homePath = process.env.NODE_ENV === 'production'
  ? '/'
  : '/home'

const router = createBrowserRouter(
  [
    {
      path: homePath,
      element: <App />
    },
    {
      path: "/preproduction",
      element: <Preproduction />,
    }, {
      path: "/production",
      element: <Production />,
    }, {
      path: "/postproduction",
      element: <Postproduction />,
    },
  ],
  { basename: '/akira-report' }
);

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <div className='container'>
      <Header />
      <RouterProvider router={router} />
      <ScrollToTop
        className='custom-scroll-to-top'
        smooth
        color="#B5221A"
      />
      <Footer />
    </div>
  </StrictMode>
);